import { Component, OnInit, ɵConsole } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BidderRegistrationService } from 'src/app/Shared/Services/bidder-registration.service';
import { PLBidderRegistration } from 'src/app/Shared/Model/pl-bidder-registration';

import { timer, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";
import { error } from 'protractor';
import { validateHorizontalPosition } from '@angular/cdk/overlay';
import { rendererTypeName } from '@angular/compiler';
declare var $: any;

@Component({
  selector: 'app-bidder-registration',
  templateUrl: './bidder-registration.component.html',
  styleUrls: ['./bidder-registration.component.css']
})
export class BidderRegistrationComponent implements OnInit {

  loaders: boolean = false; edited: Boolean; DisableBankDetails: Boolean;
  imageUrl: string = "assets/img/DefaultImageicon.png";
  fileUpload: File = null;
  OrgTypeList: any = [];
  // CityList: any = [];
  BidderDocsList: any = [];
  EstYearList: any = [];
  MultipalFile: any = [];
  FrmBidderReg: FormGroup;
  modelBidderReg: PLBidderRegistration;
  chkTrue: any = ''; base64url: any; uploadfilename: any;
  RegAmount: string;

  CGSTAmount: number; SGSTAmount: number;

  mobileNo: string;
  tempOTP: string;
  VerifyDisable: boolean = true;
  SaveAndContinueToPayment: boolean = true;
  txtGenerate = 'Send OTP';
  readonly = true;
  IsOtpDisable: boolean = false;
  isDisabledMob: boolean = true;

  public timerSub: Subscription;
  public countDownValue: number;

  AuctionCategoryList: any = [];

  documentListValid: any = [];
  DocuRequired: boolean = true;
  findDocId: any = [];
  AutoId: number;
  constructor(private Fb: FormBuilder, private router: Router, private MsgService: ToastrService,
    private BidderRegService: BidderRegistrationService) { }

  ngOnInit() {

    this.BindAllDDL();
    this.IsValidate();
    this.DisableBankDetails = false;
    //this.FillBidderDocuments();
    // this.setValidators();
  }
  handleFileInput(file: FileList, id: string) {
    this.fileUpload = file.item(0);
    //for show image
    var reader = new FileReader();
    reader.onload = (event: any) => {
      $("#img_" + id).attr("src", event.target.result);
    }
    reader.readAsDataURL(this.fileUpload);
  }
  // changeCheck(event, docs, id) {
  //   // this.chkTrue = event.source.checked;
  //   // alert(event.source.checked);
  //   if (event.source.checked) {
  //     docs.doccheck = 'true';
  //   }
  //   else {
  //     docs.doccheck = 'false';
  //     let removeIndex = this.MultipalFile.findIndex(item => item.DocId == docs.DocId);
  //     this.MultipalFile.splice(removeIndex, 1);
  //     $("#img_" + id).attr("src", "assets/img/DefaultImageicon.png");
  //   }
  // }
  FileUpload(event: any, DocId: number, id: string, docs) {

    let files = new FileReader();
    let file = event.target.files[0];
    var FileSize = (file.size / 1024);
    let filelength = event.target.files.length;
    if (filelength == '0') {
      return;
    }

    var mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      alert('Only images are supported.');
      return
    }
    else if (FileSize > 2000) {
      alert('Max file size allowed is 2 MB. Allowed file types are : *.jpg;*.png;*.jpeg;');
      return;
    }
    this.uploadfilename = file.name;
    files.readAsDataURL(file);
    files.onload = (event: any) => {

      $("#img_" + id).attr("src", event.target.result);
      $("#img_popup_" + id).attr("href", event.target.result);

      this.base64url = files.result;
      let removeIndex = this.MultipalFile.findIndex(item => item.DocId == DocId);
      if (removeIndex > 0) {
        this.MultipalFile.splice(removeIndex, 1);
      }
      this.MultipalFile.push({ 'DocId': DocId, 'DocName': docs.DocDesc, 'file_base64': this.base64url.split(",")[1] });
      // console.log(this.MultipalFile);
      // this.compareArray();
    }
  }
  IsValidate() {
    this.FrmBidderReg = this.Fb.group({
      ddlOrgType: [null, Validators.required],
      txtCompanyName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      txtRegistrationNo: [null],
      ddlEstblYear: [''],
      txtRegisteredAddress: ['', Validators.required],
      //ddlCity: ['', Validators.required],
      txtFirmCity: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      txtPostalCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      txtPanNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      // txtGstNo: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      txtGstNo: [''],
      txtNameOfAuthorizedRepresentative: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      txtMobileNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      txtDesignation: [''],//, [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      txtEmail: ['', Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')],
      txtBanKName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      txtBranchName: ['', Validators.required],
      txtNameAsInBankAccount: ['', Validators.required],
      txtAccountNo: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(18)]],
      txtIfscCode: ['', [Validators.required]],
      //  chkDocs: ['', Validators.required],
      chkAmount: ['', Validators.required],
      txtEnterOTP: [''],
      ddlAuctionCategoryType: [null, Validators.required],


    });
  }
  OnChange(event) {
    // this.setValidators();
    if (event.value == 2) {
      this.FrmBidderReg.controls['txtRegistrationNo'].disable();
    }
    else {
      this.FrmBidderReg.controls['txtRegistrationNo'].enable();
    }
  }
  public startTimer() {
    const startValue = 2 * 60;
    this.timerSub = timer(0, 1000).pipe(
      take(startValue + 1),
      map(value => startValue - value)
    ).subscribe(
      value => {
        this.countDownValue = value
        if (value == 0) {
          this.tempOTP = null;
          this.readonly = true;
          this.IsOtpDisable = false;
          // this.FrmBidderReg.get('txtEnterOTP').reset();
        }
      },
      null,
      () => this.timerSub = null
    );
  }
  ChkValidation(): boolean {
    if (this.FrmBidderReg.controls['txtAccountNo'].value == '') {
      this.MsgService.warning('Account No. Is Required...!');
      return false;
    } else this.mobileNo = this.FrmBidderReg.controls['txtMobileNo'].value;
    if (this.mobileNo == '') {
      this.MsgService.warning('Enter Mobile No.');
      return false;
    }
    return true;
  }
  GenerateOTP() {
    //debugger;
    //if (this.ChkValidation() == true) {
    this.txtGenerate = 'OTP Sending..';
    let mobileNo = this.FrmBidderReg.controls['txtMobileNo'].value;
    this.BidderRegService.GetOTP(mobileNo).subscribe(result => {
      if (result.SuccessCD == 1) {
        this.MsgService.success(result.Msg);
        this.VerifyDisable = false;
        this.tempOTP = result;
        this.IsOtpDisable = true;
        this.startTimer();
        this.readonly = false;
        this.isDisabledMob = false;
        this.txtGenerate = 'Resend OTP';

      } else if (result.SuccessCD == 2) {
        this.MsgService.warning(result.Msg);
        this.txtGenerate = 'Send OTP';
        this.isDisabledMob = true;

      }
      else {
        this.MsgService.warning(result.Msg);
      }
      this.txtGenerate = 'Send OTP';
      this.isDisabledMob = true;
    });
    // }
  }
  CheckOTP() {
    let mobno = this.FrmBidderReg.controls['txtMobileNo'].value;
    let password = this.FrmBidderReg.controls['txtEnterOTP'].value;
    if (password == '') {
      this.MsgService.warning('Enter OTP..!');
      return;
    }
    this.BidderRegService.CheckOTP(mobno, password).subscribe(result => {
      if (result.SuccessCD == 1) {

        this.SaveAndContinueToPayment = false;
        this.VerifyDisable = true;
        this.readonly = true;
        this.MsgService.success('Mobile Number Verified!');
        this.isDisabledMob = false;

        //this.countDownValue = null;
        this.timerSub = null;
        this.DisableBankDetails = true;
      }
      else {
        this.MsgService.warning('OTP Not matched!');
      }
    });
    this.SaveAndContinueToPayment = true
  }
  RegAmountList: any = [];
  BindAllDDL() {

    this.BidderRegService.FillAllDDL().subscribe(respdata => {
      if (respdata.SuccessCD == 1) {
        if (respdata.RespData != null) {
          this.OrgTypeList = respdata.RespData.Table
          // this.CityList = respdata.RespData.Table1;

          // this.RegAmount = respdata.RespData.Table2[0]["FinalAmt"];

          let a = Number(respdata.RespData.Table2[0]["GstAmt"])
          this.CGSTAmount = a / 2;
          this.SGSTAmount = a / 2;
          this.RegAmountList = respdata.RespData.Table2;
          this.BidderDocsList = respdata.RespData.Table3;
          this.EstYearList = respdata.RespData.Table4;
          this.AuctionCategoryList = respdata.RespData.Table5;
        }
      } else {
        if (respdata.SuccessCD == 2) {
          this.MsgService.warning(respdata.Msg);
        }
        else { this.MsgService.error('Not Found'); }
      }
    })
  }

  FillBidderDocuments() {
    this.BidderRegService.FillBidderDocuments().subscribe((Response) => {
      if (Response.SuccessCD == 1) {
        if (Response.RespData != null) {
          this.BidderDocsList = Response.RespData;
        }
      } else {
        if (Response.SuccessCD == 2) {
          this.MsgService.warning(Response.Msg);
        }
        else { this.MsgService.error('Not Found'); }
      }
    }, (error) => {
      alert(error.message);
    })
  }

  EstYearSelectedTextval: any = 0;
  onChange(event) {
    this.EstYearSelectedTextval = 0;
    this.EstYearSelectedTextval = event.source.selected.viewValue == null ? 0 : event.source.selected.viewValue;
  }

  AuctionCategorySelectVal: any = 0;
  AuctionCategoryListFilter: any = [];
  BidderDocsListFilter: any = [];

  OnCategoryChange(event) {
    this.AuctionCategorySelectVal = 0;
    this.AuctionCategorySelectVal = event.source.value;
    if (this.AuctionCategorySelectVal) {
      this.AuctionCategoryListFilter = this.RegAmountList.filter(m => m.AuctCtgid == this.AuctionCategorySelectVal);
      this.RegAmount = this.AuctionCategoryListFilter[0]["FinalAmt"];

      // change 12-08-2020 Filter Docs List Category wise
      this.BidderDocsListFilter = this.BidderDocsList.filter(m => m.AuctCtgid == this.AuctionCategorySelectVal);
      //console.table(this.BidderDocsListFilter);
    }
  }

  documentValid(): boolean {
    this.DocuRequired = true;
    let count = this.BidderDocsListFilter.length;
    this.documentListValid = [];
    for (let i = 0; i < count; i++) {
      if (this.BidderDocsListFilter[i]['Mandatory'] == 'Yes') {
        this.documentListValid.push({ 'DocId': this.BidderDocsListFilter[i]['DocId'], 'DocDesc': this.BidderDocsListFilter[i]['DocDesc'] });
      }
    }
    if (this.documentListValid.length > 0) {

      if (this.MultipalFile.length > 0) {
        for (let i = 0; i < this.documentListValid.length; i++) {
          this.findDocId = this.MultipalFile.findIndex(item => item.DocId == this.documentListValid[i]['DocId']);
          if (this.findDocId >= 0) {

          } else {
            this.MsgService.warning('Required Document Must be Upload Compulsory!');
            this.DocuRequired = false;
            return false;
          }
        }

      } else {
        this.MsgService.warning('Required Document Must be Upload Compulsory!');
        this.DocuRequired = false;
        return false;
      }

    }
  }

  SaveData() {
    try {
      /// write code to check img upload 
      // if (this.MultipalFile.length == 0) {
      //   this.MsgService.warning('Atleast One Documents is Required....!!');
      //   return;
      // }

      this.documentValid();
      if (this.DocuRequired == false) {
        return;
      }
      this.loaders = true;
      this.modelBidderReg = new PLBidderRegistration();
      this.modelBidderReg.Ind = 2;
      this.modelBidderReg.OrgCode = 101;
      this.modelBidderReg.CityCode = 1001001;
      //this.FrmBidderReg.get('ddlCity').value;
      this.modelBidderReg.LegalStatusCd = this.FrmBidderReg.get('ddlOrgType').value;
      this.modelBidderReg.EstbYear = this.EstYearSelectedTextval;//this.FrmBidderReg.get('ddlEstblYear').value;
      this.modelBidderReg.CompanyName = this.FrmBidderReg.controls['txtCompanyName'].value;
      this.modelBidderReg.RegistrationNo = this.FrmBidderReg.controls['txtRegistrationNo'].value;
      this.modelBidderReg.RegisteredAddress = this.FrmBidderReg.controls['txtRegisteredAddress'].value;
      this.modelBidderReg.FirmCity = this.FrmBidderReg.controls['txtFirmCity'].value;
      this.modelBidderReg.PostalCode = this.FrmBidderReg.controls['txtPostalCode'].value;
      this.modelBidderReg.PanNo = this.FrmBidderReg.controls['txtPanNo'].value;
      this.modelBidderReg.GstNo = this.FrmBidderReg.controls['txtGstNo'].value;
      this.modelBidderReg.NameOfAuthorizedReprestator = this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].value;
      this.modelBidderReg.MobileNo = this.FrmBidderReg.controls['txtMobileNo'].value;
      this.modelBidderReg.Designation = this.FrmBidderReg.controls['txtDesignation'].value;
      this.modelBidderReg.Email = this.FrmBidderReg.controls['txtEmail'].value;
      this.modelBidderReg.BankName = this.FrmBidderReg.controls['txtBanKName'].value;
      this.modelBidderReg.BranchName = this.FrmBidderReg.controls['txtBranchName'].value;
      this.modelBidderReg.NameAsInBankAccount = this.FrmBidderReg.controls['txtNameAsInBankAccount'].value;
      this.modelBidderReg.AccountNo = this.FrmBidderReg.controls['txtAccountNo'].value;
      this.modelBidderReg.IfscCode = this.FrmBidderReg.controls['txtIfscCode'].value;
      this.modelBidderReg.RegAmount = Number(this.RegAmount);//5;

      this.modelBidderReg.CGSTAmount = this.CGSTAmount;
      this.modelBidderReg.SGSTAmount = this.SGSTAmount;
      this.modelBidderReg.RegImageUploadList = this.MultipalFile;

      /************* Change 12-08-2020 *********/
      this.modelBidderReg.AuctCtgId = this.AuctionCategorySelectVal;
      this.modelBidderReg.PaymentMode = 1; // 1 for online default


      this.BidderRegService.SaveBidderRegistration(this.modelBidderReg).subscribe(respdata => {
        if (respdata.SuccessCD == 1) {
          this.MsgService.success(respdata.Msg);
          this.Clear();
          this.SaveAndContinueToPayment = true;
          this.loaders = false;

          window.open(respdata.RespData);

          //************ Call Payment Method ***********/
          //  this.eauctionPymnt(respdata.RespData);
          //************ End **************************/         

        } else if (respdata.SuccessCD == 2) {
          this.MsgService.warning(respdata.Msg);

          this.Clear();
          this.SaveAndContinueToPayment = true;
          this.loaders = false;
        }
        else {
          this.MsgService.warning(respdata.Msg);
          this.loaders = false;
        }
      });
    } catch (error) { }
  }

  eauctionPymnt(pymntString) {
    // debugger;
    // console.log(pymntString);
    if (pymntString != null && pymntString != '') {
      let configJson = {
        'tarCall': false,
        'features': {
          'showPGResponseMsg': false,
          'enableExpressPay': true,
          'enableNewWindowFlow': true    //for hybrid applications please disable this by passing false
        },
        'consumerData': {
          'deviceId': 'WEBSH2',	//possible values 'WEBSH1', 'WEBSH2' and 'WEBMD5'
          'token': pymntString.GenerateHash,
          //'returnUrl': 'http://localhost:4200/respcalculation',
          'responseHandler': this.handleResponse,
          //'redirectOnClose': 'http://localhost:4200/respcalculation',
          'merchantLogoUrl': 'https://www.paynimo.com/CompanyDocs/company-logo-md.png',
          'paymentMode': 'all',
          'merchantId': 'L34703', //'L61282', //'L34703'
          'currency': 'INR',
          'consumerId': pymntString.RegNo,
          'consumerMobileNo': pymntString.MobileNo,
          'consumerEmailId': pymntString.EmailId,
          'txnId': pymntString.TxnRegNo,   //Unique merchant transaction ID 7932646187ARTTAW  9214235882GASMHC
          'items': [{
            'itemId': 'NAGAR',
            'amount': pymntString.RegAmt,
            'comAmt': '0'
          }],
          'customStyle': {
            'PRIMARY_COLOR_CODE': '#3977b7',   //merchant primary color code
            'SECONDARY_COLOR_CODE': '#FFFFFF',   //provide merchant's suitable color code
            'BUTTON_COLOR_CODE_1': '#1969bb',   //merchant's button background color code
            'BUTTON_COLOR_CODE_2': '#FFFFFF'   //provide merchant's suitable color code for button text
          }
        }
      };
      /*if (returnUrl) {
        configJson.consumerData["returnUrl"] = returnUrl;
      }*/
      var checkoutLoop = setInterval(function () {
        if (typeof $["pnCheckout"] != 'undefined') {
          $["pnCheckout"](configJson);
          if (configJson.features.enableNewWindowFlow) {
            window["pnCheckoutShared"].openNewWindow();
          }
          clearInterval(checkoutLoop);
        }
      }, 500);
    }
    else {
      this.MsgService.warning('Record Not Saved...!');
    }
  }

  handleResponse(res) {
    this.loaders = true;
    // debugger
    // console.log(res);
    if (res != null) {
      var request = new XMLHttpRequest()
      // Open a new connection, using the GET request on thse URL endpoint

      request.open('POST', 'http://115.124.113.64/JMCEauctionAPI/api/BidderRegistration/UpdateTxnResponse', true)

      // request.open('POST', 'http://localhost:49674/api/BidderRegistration/UpdateTxnResponse', true)

      request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      var resString = { 'resString': res };

      request.send(JSON.stringify(resString))
      window.onbeforeunload = null;
      this.loaders = false;
      request.onload = function () {
        // Do whatever with response        
        if (request.responseText) {

          let encrpt = window.btoa(JSON.stringify(request.responseText));
          localStorage.setItem('getPymntResp', encrpt);
          // alert('Firm Registered Success');

          location.href = "PrintReceipt";

        }
      }
    }
  }

  Clear() {
    this.FrmBidderReg.reset('');
    this.SaveAndContinueToPayment = true;
    this.isDisabledMob = true;
    this.DisableBankDetails = false;
    this.timerSub = null;
    $("#img_" + 0).attr("src", "assets/img/DefaultImageicon.png");
    $("#img_" + 1).attr("src", "assets/img/DefaultImageicon.png");
    $("#img_" + 2).attr("src", "assets/img/DefaultImageicon.png");
    $("#img_" + 3).attr("src", "assets/img/DefaultImageicon.png");
  }

  get chkValidForOTP() {
    if (this.FrmBidderReg.controls['ddlOrgType'].value == '' || this.FrmBidderReg.controls['ddlOrgType'].value == null || this.FrmBidderReg.controls['ddlOrgType'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtCompanyName'].value == '' || this.FrmBidderReg.controls['txtCompanyName'].value == null || this.FrmBidderReg.controls['txtCompanyName'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['ddlEstblYear'].value == '' || this.FrmBidderReg.controls['ddlEstblYear'].value == null || this.FrmBidderReg.controls['ddlEstblYear'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['txtRegisteredAddress'].value == '' || this.FrmBidderReg.controls['txtRegisteredAddress'].value == null || this.FrmBidderReg.controls['txtRegisteredAddress'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtFirmCity'].value == '' || this.FrmBidderReg.controls['txtFirmCity'].value == null || this.FrmBidderReg.controls['txtFirmCity'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtPostalCode'].value == '' || this.FrmBidderReg.controls['txtPostalCode'].value == null || this.FrmBidderReg.controls['txtPostalCode'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtPanNo'].value == '' || this.FrmBidderReg.controls['txtPanNo'].value == null || this.FrmBidderReg.controls['txtPanNo'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['txtGstNo'].value == '' || this.FrmBidderReg.controls['txtGstNo'].value == null || this.FrmBidderReg.controls['txtGstNo'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].value == '' || this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].value == null || this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtMobileNo'].value == '' || this.FrmBidderReg.controls['txtMobileNo'].value == null || this.FrmBidderReg.controls['txtMobileNo'].invalid == true) {
      return true;
    }

    if (this.FrmBidderReg.controls['ddlAuctionCategoryType'].value == '' || this.FrmBidderReg.controls['ddlAuctionCategoryType'].value == null || this.FrmBidderReg.controls['ddlAuctionCategoryType'].invalid == true) {
      return true;
    }

    return false;
  }

  get chkValidForSavePayment() {
    if (this.FrmBidderReg.controls['ddlOrgType'].value == '' || this.FrmBidderReg.controls['ddlOrgType'].value == null || this.FrmBidderReg.controls['ddlOrgType'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtCompanyName'].value == '' || this.FrmBidderReg.controls['txtCompanyName'].value == null || this.FrmBidderReg.controls['txtCompanyName'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['ddlEstblYear'].value == '' || this.FrmBidderReg.controls['ddlEstblYear'].value == null || this.FrmBidderReg.controls['ddlEstblYear'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['txtRegisteredAddress'].value == '' || this.FrmBidderReg.controls['txtRegisteredAddress'].value == null || this.FrmBidderReg.controls['txtRegisteredAddress'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtFirmCity'].value == '' || this.FrmBidderReg.controls['txtFirmCity'].value == null || this.FrmBidderReg.controls['txtFirmCity'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtPostalCode'].value == '' || this.FrmBidderReg.controls['txtPostalCode'].value == null || this.FrmBidderReg.controls['txtPostalCode'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtPanNo'].value == '' || this.FrmBidderReg.controls['txtPanNo'].value == null || this.FrmBidderReg.controls['txtPanNo'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['txtGstNo'].value == '' || this.FrmBidderReg.controls['txtGstNo'].value == null || this.FrmBidderReg.controls['txtGstNo'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].value == '' || this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].value == null || this.FrmBidderReg.controls['txtNameOfAuthorizedRepresentative'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtMobileNo'].value == '' || this.FrmBidderReg.controls['txtMobileNo'].value == null || this.FrmBidderReg.controls['txtMobileNo'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['txtDesignation'].value == '' || this.FrmBidderReg.controls['txtDesignation'].value == null || this.FrmBidderReg.controls['txtDesignation'].invalid == true) {
    //   return true;
    // }
    // if (this.FrmBidderReg.controls['txtEmail'].value == '' || this.FrmBidderReg.controls['txtEmail'].value == null || this.FrmBidderReg.controls['txtEmail'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['txtBanKName'].value == '' || this.FrmBidderReg.controls['txtBanKName'].value == null || this.FrmBidderReg.controls['txtBanKName'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtBranchName'].value == '' || this.FrmBidderReg.controls['txtBranchName'].value == null || this.FrmBidderReg.controls['txtBranchName'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtNameAsInBankAccount'].value == '' || this.FrmBidderReg.controls['txtNameAsInBankAccount'].value == null || this.FrmBidderReg.controls['txtNameAsInBankAccount'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtAccountNo'].value == '' || this.FrmBidderReg.controls['txtAccountNo'].value == null || this.FrmBidderReg.controls['txtAccountNo'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtIfscCode'].value == '' || this.FrmBidderReg.controls['txtIfscCode'].value == null || this.FrmBidderReg.controls['txtIfscCode'].invalid == true) {
      return true;
    }
    // if (this.FrmBidderReg.controls['chkDocs'].value == '' || this.FrmBidderReg.controls['chkDocs'].value == null || this.FrmBidderReg.controls['chkDocs'].invalid == true) {
    //   return true;
    // }
    if (this.FrmBidderReg.controls['chkAmount'].value == '' || this.FrmBidderReg.controls['chkAmount'].value == null || this.FrmBidderReg.controls['chkAmount'].invalid == true) {
      return true;
    }
    if (this.FrmBidderReg.controls['txtEnterOTP'].value == '' || this.FrmBidderReg.controls['txtEnterOTP'].value == null || this.FrmBidderReg.controls['txtEnterOTP'].invalid == true) {
      return true;
    }
    return false;
  }


  /***************** Start conditionally validation **************/

  private setValidators(): void {
    // debugger
    // this.FrmBidderReg.get('ddlOrgType').valueChanges.subscribe(
    //   (result) => {
    //     if (result === 'Individual') {
    //       this.FrmBidderReg.controls['txtRegistrationNo'].setValidators(Validators.required);
    //       console.log('validator set');
    //     } else {
    //       this.FrmBidderReg.get('txtRegistrationNo').setValidators(null);
    //     }
    //     this.FrmBidderReg.get('txtRegistrationNo').updateValueAndValidity();
    //   }
    // );


    this.FrmBidderReg.controls['txtRegistrationNo'].setValidators(Validators.required);
    this.FrmBidderReg.get('txtRegistrationNo').updateValueAndValidity();
    $("#txtRegNo").css("display", "inherit");
  }

}
